import Model from '@/lib/data/Model';
import Store from '../store/store'; // eslint-disable-line

class User extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'email',
        { name: 'email_verified', type: 'bool', defaultValue: false },
        'first_name',
        'last_name',
        'full_name',
        { name: 'password_available', type: 'bool', defaultValue: true },
        'password',
        'confirm_password',
        'current_password',
        'organization_id',
        'representative_id',
        'photo_path',
        'time_zone',
        'gPicture',
        { name: 'record_state', defaultValue: 1, type: 'int' },
        { name: 'cell_phone', defaultValue: '' },
        'client_id',
        'access_role_id',
        {
            name: 'country_authority_level',
            defaultValue: 'all',
        },
        {
            name: 'authority_country_codes',
            defaultValue: [],
        },
        {
            name: 'insured_user_mode',
            type: 'bool',
            defaultValue: false,
        },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data, Store);
        this.init();
    }

    get fullName() {
        return this.first_name ? `${this.first_name} ${this.last_name || ''}` : this.full_name;
    }

    get isEngineer() {
        return !!this.representative_id;
    }

    get isActive() {
        return this.record_state == 1;
    }

    get photoPath() {
        if (this.gPicture) {
            return this.gPicture;
        }
        const photoPath = this.photo_path;

        if (photoPath) {
            return `/repzoneproxy/image?path=${photoPath}`;
        }

        return photoPath || '';
    }

    api = [
        {
            name: 'loginAs',
            url: '/auth/loginas',
            params: ['email'],
        },
        {
            name: 'save',
            url: '/user/save',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        {
            name: 'delete',
            url: '/user/delete',
            params: ['id'],
        },
        {
            name: 'getCountryAuthority',
            url: '/user/claimuser_country',
            params: ['id'],
            method: 'GET',
        },
    ];
}

export default User;
